import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;

// Add Review
export const addReview = createAsyncThunk("review/addReview", async (reviewData, { rejectWithValue }) => {

  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${BASE_URL}/api/reviews/add`, reviewData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }

  // try {
  //   const token = localStorage.getItem("token");
  //   const response = await axios.post(`${BASE_URL}/api/reviews/${orderId}/product/${productId}/review`, reviewData,
  //     { headers: { Authorization: `Bearer ${token}` } }

  //   );
  //   return response.data;
  // } catch (error) {
  //   return rejectWithValue(error.response?.data || "Failed to add review");
  // }
});

// ✅ Fetch Reviews for a Product (with optional rating filter)
export const fetchReviews = createAsyncThunk("reviews/fetchReviews", async ({ productId, rating }, { rejectWithValue }) => {
  console.log("rating checking+++", productId, rating);
  try {
    const url = rating ? `${BASE_URL}/api/reviews/product/${productId}?rating=${rating}` : `${BASE_URL}/api/reviews/product/${productId}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getProductRating = createAsyncThunk("reviews/getProductRating",
  async (productId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/api/reviews/product/${productId}/rating`);
      return { productId, ...response.data }; // Include productId
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


const reviewSlice = createSlice({
  name: "review",
  initialState: {
    reviews: [],
    loading: false,
    error: null,
    message: null,
    totalReviews: null,
    totalPages: null,
    currentPage: null,
    averageRating: null,
    ratings: {}, // ⭐ New: store ratings per product

  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(addReview.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(addReview.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = [...state.reviews, action.payload.review]; // Append new review
        state.message = action.payload.message;
      })
      .addCase(addReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something went wrong!123";
        state.message = action.payload?.message || "Failed to add review.123";
      })

      .addCase(fetchReviews.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReviews.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.reviews = action.payload.reviews;
        state.message = action.payload.message;
        state.totalReviews = action.payload.totalReviews;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.currentPage;
      })
      .addCase(fetchReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error;
        state.message = action.payload.message;
        state.reviews = [];
        state.totalReviews = null;
        state.totalPages = null;
        state.currentPage = null;
      })

      .addCase(getProductRating.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductRating.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        const { productId, averageRating, totalReviews } = action.payload;
        state.ratings[productId] = {
          averageRating,
          totalReviews,
        };
      })
  },
});


export default reviewSlice.reducer;
